import React, { useEffect, useRef, useState } from "react";
import { Dialog } from "primereact/dialog";
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import "../../assets/scss/theme-base/ModelAddConstruction.css";
import { Paginator } from "primereact/paginator";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import Intersection from "../Plan/intersection";
import { DataTable } from "primereact/datatable";
import { Image } from "primereact/image";
import { statusFilterTemplate } from "../../constants/status";
import { QuantityTemplate, statusTemplate } from "../../components/utils";
import FormatDate from "../Report/FormatDate";
import { formatDate } from "../Plan/ModalShowPlan";
import QR from "../Plan/QR";

const defaultImageUrl = "https://static.thenounproject.com/png/1269202-200.png";

function formatQuantity(quantity) {
    if (quantity !== undefined && quantity !== null) {
        let formatted = quantity.toString();

        formatted = formatted.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return formatted;
    } else {
        return 0;
    }
}

export const imageTemplate = (rowData) => {
    return (
        <Image
            src={`${rowData?.categoryImage}` || defaultImageUrl}
            alt="Category Image"
            imageStyle={{ borderRadius: "20%", width: "40px", height: "40px" }}
            preview
            onError={(e) => (e.target.src = defaultImageUrl)}
        />
    );
};
export const teamImageTemplate = (rowData) => {
    return rowData.teamImage ? (
        <Image
            src={`${rowData?.teamImage}` || defaultImageUrl}
            alt="Category Image"
            imageStyle={{ borderRadius: "20%", width: "40px", height: "40px" }}
            preview
            onError={(e) => (e.target.src = defaultImageUrl)}
        />
    ) : (
        <></>
    );
};

const ModalFilterCategoryTechnique = ({ visible, onHide, data }) => {
    const [dialogLocationVisible, setDialogLocationVisible] = useState(false);
    const [selectFactoryCode, setSelectFactoryCode] = useState(null);
    const [first, setFirst] = useState(0);
    const [rows, setRows] = useState(10);
    const [selectedProducts, setSelectedProducts] = useState(null);
    const [qrDetail, setQrDetail] = useState(null);
    const [visible3, setVisible3] = useState(false);
    const [selectedRowData, setSelectedRowData] = useState(null);
    const [visible1, setVisible1] = useState(false);
    const [rowClick, setRowClick] = useState(true);
    const [openModal, setOpenModal] = useState(false);

    const listPermissions =
        JSON.parse(localStorage.getItem("userPermissions")) || {};

    const handleDetailScanned = (detail) => {
        setQrDetail(detail);
    };

    const handleTeamProgress = (rowData) => {
        setSelectFactoryCode(rowData.factoryCode);
        setDialogLocationVisible(true);
    };
    const onPageChange = (event) => {
        const newFirst = event.first;
        const newRows = event.rows;

        setFirst(newFirst);
        setRows(newRows);
    };

    const paginatedData = data?.slice(first, first + rows);

    return (
        <Dialog
            visible={visible}
            onHide={() => {
                setFirst(0);
                onHide();
            }}
            className="responsive-dialog"
            header="Lọc theo hạng mục"
            modal
            style={{ width: "80vw", height: "80vh" }}
        >
            <div className="p-3 border-round-md">
                <div>
                    <DataTable
                        rowClassName="custom-row-class-factory-inprogress"
                        size="small"
                        value={paginatedData}
                        emptyMessage="Không có dữ liệu"
                        scrollable
                        scrollHeight="550px"
                    >
                        <Column
                            header="STT"
                            body={(rowData, options) => (
                                <div className="text-center">
                                    {first + options.rowIndex + 1}
                                </div>
                            )}
                            frozen
                            style={{ width: "3%", minWidth: "60px" }}
                            alignHeader={"center"}
                            align={"center"}
                        ></Column>
                        <Column
                            header="Tên công trình"
                            field="Building.name"
                            filterPlaceholder="Tìm kiếm tên công trình"
                            style={{ width: "4%", minWidth: "200px" }}
                            filter
                            frozen
                        ></Column>
                        <Column
                            header="Mã ĐH"
                            field="orderCode"
                            filterPlaceholder="Tìm kiếm mã đơn hàng"
                            style={{ width: "6%", minWidth: "100px" }}
                            filter
                            frozen
                        ></Column>
                        <Column
                            header="Mã nhà máy"
                            field="factoryCode"
                            style={{ width: "8%", minWidth: "200px" }}
                            filter
                            frozen
                            filterPlaceholder="Tìm kiếm mã nhà máy"
                        ></Column>
                        <Column
                            header="Hạng mục"
                            field="categoryName"
                            filterPlaceholder="Tìm kiếm hạng mục"
                            style={{
                                width: "8%",
                                minWidth: "200px",
                                lineHeight: "1.5",
                            }}
                            frozen
                            filter
                        ></Column>
                        <Column
                            header="Hình ảnh"
                            body={imageTemplate}
                            style={{ width: "5%", minWidth: "70px" }}
                            alignHeader={"center"}
                            frozen
                            align={"center"}
                        ></Column>

                        <Column
                            header="SL"
                            field="quantity"
                            style={{ width: "3%", minWidth: "60px" }}
                            body={QuantityTemplate}
                            alignHeader={"center"}
                            align={"center"}
                        ></Column>
                        <Column
                            header="ĐVT"
                            field="unit"
                            filterPlaceholder="Tìm kiếm đơn vị tính"
                            style={{ width: "3%", minWidth: "60px" }}
                            filter
                        ></Column>
                        <Column
                            header="Mã SP"
                            field="productCode"
                            filterPlaceholder="Tìm kiếm mã sản phẩm"
                            style={{ width: "5%", minWidth: "100px" }}
                            filter
                        ></Column>

                        <Column
                            header="Vật tư chính"
                            field="materialName"
                            filterPlaceholder="Tìm kiếm vật tư chính"
                            style={{ width: "8%", minWidth: "300px" }}
                            filter
                        ></Column>
                        <Column
                            header="Hạng mục gia công"
                            field="categoryMaterial"
                            filterPlaceholder="Tìm kiếm hạng mục gia công"
                            style={{ width: "8%", minWidth: "165px" }}
                            filter
                        ></Column>

                        <Column
                            header="Kế hoạch hoàn thành"
                            field="intendFinishDate"
                            body={(rowData) =>
                                formatDate(rowData.intendFinishDate)
                            }
                            style={{ width: "8%", minWidth: "120px" }}
                            sortable
                            alignHeader={"center"}
                            align={"center"}
                        ></Column>

                        <Column
                            header="Trạng thái"
                            field="status"
                            body={statusTemplate}
                            style={{ width: "12%", minWidth: "150px" }}
                            filter
                            filterElement={statusFilterTemplate}
                            pt={{ filterButtonbar: { className: "hidden" } }}
                            alignHeader={"center"}
                            align={"center"}
                        ></Column>
                        <Column
                            header="Ngày đặt vật tư"
                            style={{ width: "6%", minWidth: "135px" }}
                            sortable
                            field="materialOrderingDate"
                            body={(rowData) =>
                                formatDate(rowData.materialOrderingDate)
                            }
                            alignHeader={"center"}
                            align={"center"}
                        ></Column>
                        <Column
                            header="Ngày đặt hàng gia công"
                            style={{ width: "6%", minWidth: "195px" }}
                            sortable
                            field="machiningOrderingDate"
                            // body={(rowData) =>
                            //     formatDate(
                            //         rowData.machiningOrderingDate
                            //     )
                            // }
                            body={(rowData) =>
                                rowData.notMachining
                                    ? "Không cần hàng gia công"
                                    : formatDate(rowData.machiningOrderingDate)
                            }
                            alignHeader={"center"}
                            align={"center"}
                        ></Column>
                        <Column
                            header="Ngày ra BOM"
                            style={{ width: "6%", minWidth: "120px" }}
                            field="bomProductionDate"
                            sortable
                            body={(rowData) =>
                                formatDate(rowData.bomProductionDate)
                            }
                            align={"center"}
                            alignHeader={"center"}
                        ></Column>
                        <Column
                            header="Ghi chú"
                            field="technicalNote"
                            style={{
                                minWidth: "150px",
                                height: "55px",
                            }}
                        ></Column>

                        <Column
                            header="Định vị"
                            body={(rowData) => (
                                <div className="text-center">
                                    <i
                                        className="pi pi-map-marker cursor-pointer"
                                        onClick={() =>
                                            handleTeamProgress(rowData)
                                        }
                                    ></i>
                                    <p>{rowData.teamWorking}</p>
                                </div>
                            )}
                            style={{
                                minWidth: "150px",
                            }}
                            alignHeader={"center"}
                            align={"center"}
                        ></Column>
                        <Column
                            header="In QR"
                            body={(rowData) => (
                                <div className="text-center">
                                    <Button
                                        onClick={() => {
                                            setQrDetail(rowData);
                                            setVisible3(true);
                                        }}
                                        icon="pi pi-qrcode"
                                        rounded
                                        text
                                        severity="secondary"
                                        aria-label="QR"
                                        style={{ color: "black" }}
                                    />
                                </div>
                            )}
                            style={{ width: "8%", minWidth: "100px" }}
                            alignHeader={"center"}
                            align={"center"}
                        ></Column>
                    </DataTable>
                    <Paginator
                        first={first}
                        rows={rows}
                        totalRecords={data?.length}
                        rowsPerPageOptions={[10, 20, 30, 100, 200, 500]}
                        onPageChange={onPageChange}
                    />
                    <Intersection
                        visible={dialogLocationVisible}
                        onHide={() => setDialogLocationVisible(false)}
                        factoryCode={selectFactoryCode}
                    />
                    <QR
                        isShow={visible3}
                        hiden={() => setVisible3(false)}
                        detail={qrDetail}
                        onDetailScanned={handleDetailScanned}
                    />
                </div>
            </div>
        </Dialog>
    );
};

export default ModalFilterCategoryTechnique;
